import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'
import MyInput from '../../../components/forms/input'
import MyRichText from '../../../components/forms/richText'
import MyColumnSelect from '../../../components/select/columnSelect'

const EditFaq = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  useEffect(() => {
    axios.post('/p/content/faq/detail/get', {
      merchant_oid: merchantOid,
      faq_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setFormValue(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [merchantOid, props.data])

  const handleOk = () => {
    setErrorMsg({})
    if (!formValue.question) {
      setErrorMsg({questionEmpty: '问题不能为空'})
      return false
    }
    if (!formValue.column_oid) {
      setErrorMsg({columnEmpty: '所属栏目不能为空'})
      return false
    }

    axios.post('/p/content/faq/edit', { 
      merchant_oid: merchantOid,
      faq_oid: formValue.oid,
      question: formValue.question,
      column_oid: formValue.column_oid,
      answer: formValue.answer,
      sort: Number(formValue.sort)
    })
      .then(function (response) {
        if (response.errcode === 0) {
          handleCancel()
          props.getFaqList()
          message.success('常见问题修改成功！')
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleCancel = () => {
    setErrorMsg({})
    props.isCancel()
  }

  return (
    <Modal 
      title='编辑常见问题'
      destroyOnClose={true}
      width='800px'
      open={props.isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText="取消"
      okText="保存">

      <MyColumnSelect
        id='column_oid'
        required
        label='选择栏目'
        category={5}
        value={formValue.column_oid}
        onChange={setFormValue}
        errorMsg={errorMsg.columnEmpty}
      />

      <MyInput
        id="question"
        required
        autoFocus
        maxLength={64}
        label='问题'
        placeholder='请输入文章的标题'
        value={formValue.question}
        onChange={setFormValue}
        errorMsg={errorMsg.questionEmpty}
      />

      <MyRichText
        id='answer'
        required
        label='答案'
        value={formValue.answer}
        setValue={setFormValue}
      />

      <MyInput
        type='number'
        id="sort"
        label='排序'
        value={formValue.sort}
        onChange={setFormValue}
        styles={{ width: '60px' }}
        min={0}
        max={1000}
      />
    </Modal>
  )
}

export default EditFaq
